import React, { Component } from 'react';

import sample from '../img/showcase.mp4';


export default class Showcase extends Component {
    constructor(props) {
        super(props);
        this.state = {
            playing: true,
            muted: true
        };
        this.play = this.play.bind(this);
        this.unmute = this.unmute.bind(this);
      }

    play = () => {
        var video = document.getElementById("showcase-vid"); 
        if(video.paused){
            this.setState({
                playing: true
            })
           
            video.play()
        }else{
            this.setState({
                playing: false
            })
            
            video.pause();
        }
    }

    unmute =()=> {
        var video = document.getElementById("showcase-vid"); 
        if(video.muted){
            this.setState({
                muted: false
            })
            
            video.muted = false
        }else{
            this.setState({
                muted: true
            })
            video.muted = true
        }
    }
  
   changePlayingSVG = () =>{
    if(this.state.playing){
        return <svg xmlns="http://www.w3.org/2000/svg" currentcolor="white" width="24" height="24" viewBox="0 0 24 24"><path currentcolor="white"  d="M3 22v-20l18 10-18 10z"/></svg>
    } else{
        return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M11 22h-4v-20h4v20zm6-20h-4v20h4v-20z"/></svg> 
    }
   }

   changeMutingSVG = () =>{
       if(this.state.muted){
        return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M2 6h3.828c-1.335 2.905-1.335 9.096 0 12h-3.828c-1.311-1.108-2-3.551-2-5.995 0-2.45.692-4.9 2-6.005zm22 6.005c.005 8.031-3.145 12.864-6.121 11.864-.774-.26-9.567-5.579-9.567-5.579-1.993-2.22-1.993-10.288 0-12.508 0 0 9.161-5.476 9.548-5.633 2.691-1.086 6.136 3.82 6.14 11.856zm-3.383-7.693c-1.053-2.264-3.002-2.226-4.034.002-.588 1.271-.993 3.165-1.21 4.797h.527c1.587 0 2.873 1.287 2.873 2.875s-1.286 2.875-2.873 2.875h-.515c.217 1.603.616 3.538 1.206 4.89.988 2.271 3.062 2.232 4.033-.002 1.946-4.477 1.772-11.609-.007-15.437z"/></svg>
       }else{
           return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 17h-5v-10h5v10zm2-10v10l9 5v-20l-9 5zm15.324 4.993l1.646-1.659-1.324-1.324-1.651 1.67-1.665-1.648-1.316 1.318 1.67 1.657-1.65 1.669 1.318 1.317 1.658-1.672 1.666 1.653 1.324-1.325-1.676-1.656z"/></svg>
       }
   }

    render() {
        return (
            <div className="showcase-container">
            <video autoPlay loop muted id="showcase-vid">
                <source src={sample} type="video/mp4"></source>
            </video>
            <div className="control">
                <p onClick={this.play}>
                    {this.changePlayingSVG()}
                    </p>
                <p onClick={this.unmute}>
                    {this.changeMutingSVG()}
                    </p>
            </div>
            </div>
        )
    }
    
}


